import React, { type FC } from 'react';
import { type SalesforceMappingsViewmodel } from 'tendril-v2/src/Presentation/Views/Settings/Integrations/Salesforce/Mappings/SalesforceMappings.viewmodel';

const SalesforceMappingActions: FC<{ viewModel: SalesforceMappingsViewmodel }> = ({ viewModel }) => {
  const {
    viewState: { isSuperAdmin, isAdmin, isSalesforceAccount },
    mappingsHaveChanged,
  } = viewModel;
  const userCanEdit = isSalesforceAccount && (isAdmin || isSuperAdmin);

  return (
    <div className="flex w-full justify-end gap-8">
      <button
        onClick={() => {
          void viewModel.saveNewDispositionMap();
        }}
        type="button"
        disabled={!mappingsHaveChanged.current || !userCanEdit}
        className="disabled disabled:bg-opacity-50 disabled:cursor-not-allowed text-white inline-flex gap-2 items-center bg-app-blue-light hover:bg-opacity-90 focus:ring-2 focus:outline-none focus:ring-app-blue-lighter font-medium rounded-lg text-sm px-5 py-2.5 text-center"
      >
        Save
      </button>
    </div>
  );
};

export default SalesforceMappingActions;
